<template>
  <div class="sova-club-header">
    <h2 class="sova-club-header__title">
      {{ item?.name }}
    </h2>
    <p class="sova-club-header__text" v-html="item?.previewText"></p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useClubStore } from '@/storePinia/stores/club';

const clubStore = useClubStore();
const item = computed(() => clubStore.getItem);
</script>

<style lang="scss" scoped>
.sova-club-header {
  margin-bottom: 24px;
  &__title {
    font-weight: 600;
    font-size: rem(16);
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin-bottom: 8px;
    @include point-md {
      font-size: rem(24);
    }
  }
  &__text {
    font-size: rem(12);
    line-height: 130%;
    @include point-md {
      font-size: rem(14);
    }
  }
}
</style>
